export const gameTitle = "Праздничный пазл";
export const startText =
  'Соберите пазл за 5 минут и получите <a href="new_year2024/Правила_участия_в_квесте.pdf" target="_blank">100 баллов</a>! Перемещайте фрагменты по игровому полю, располагая все пазлы в верном порядке, чтобы увидеть тематическую открытку.';
